import { SITE_ORIGIN } from '@bookkeeper/shared/site-chrome';
import type { Locale } from '@/i18n/i18n';
import { localePath } from '@/i18n/paths';

/** Absolute www URL of a path another app serves; `locale` adds `/en`, `/uk`, `null` keeps it Polish-only. */
export function wwwUrl(path: string, locale: Locale | null) {
  return `${SITE_ORIGIN}${locale ? localePath(path, locale) : path}`;
}

export function blogUrl(locale: Locale) {
  return wwwUrl('/blog', locale);
}
